//const DefaultConfig = "http://localhost:3000/workflowapi/";
const DefaultConfig = "https://codeforgesolution.com/workflowapi/"; //live

export default DefaultConfig;
